module.exports = __webpack_public_path__ + "static/logo-light-2x-6a82a50b0400deba29701bfbfee85cbb.png";